<template>
  <div>
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <!-- <h1 class="h3 mb-0 font-weight-bold" id="v-step-0">Dashboard</h1> -->
      <!-- <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
        <i class="fas fa-download fa-sm text-white-50" id="v-step-0-1"></i> Generate Report
      </a>-->
    </div>
    <br />
    <!-- Content Row -->
    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <!-- <div @click="active = 'revenue'" style="cursor: pointer;" class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body" id="v-step-1">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Total Revenue</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">Rp. 215.000</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!-- Earnings (Monthly) Card Example -->
      <!-- <div @click="active = 'shipment'" style="cursor: pointer;" class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body" id="v-step-2">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                >All Shipment Today</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">80.000</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-shipping-fast fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->

      <!-- Earnings (Monthly) Card Example -->
      <!-- <div @click="active = 'bukalapak'" style="cursor: pointer;" class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-danger shadow h-100 py-2">
          <div class="card-body" id="v-step-3">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-danger text-uppercase mb-1"
                >Bukalapak Shipment Today</div>
                <div class="row no-gutters align-items-center">
                  <div class="col">
                    <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">200.000</div>
                  </div>
                  <div class="col">
                    <div class="progress progress-sm mr-2">
                      <div
                        class="progress-bar bg-info"
                        role="progressbar"
                        style="width: 50%"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-shopping-bag fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->

      <!-- Pending Requests Card Example -->
      <!-- <div @click="active = 'reminder'" style="cursor: pointer;" class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                >Pickup Reminder</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-user-clock fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <b-row>
      <b-col>
        <transition name="slide-fade" mode="out-in">
          <div v-if="active == 'revenue'" :key="active">
            <b-card class="border-bottom-success">
              <h1>REVENUE</h1>
              <revenue
                :chartdata="chartData"
                :options="chartOptions"
                style="width:100%; height:100%;"
              ></revenue>
            </b-card>
          </div>
          <div v-if="active == 'shipment'" :key="active">
            <b-card class="border-bottom-primary">
              <h1>SHIPMENT</h1>
              <shipment
                :chartdata="chartData2"
                :options="chartOptions"
                style="width:100%; height:100%;"
              ></shipment>
            </b-card>
          </div>
          <div v-if="active == 'bukalapak'" :key="active">
            <b-card class="border-bottom-danger">
              <h1>BUKALAPAK</h1>
              <bukalapak
                :chartdata="chartData3"
                :options="chartOptions"
                style="width:100%; height:100%;"
              ></bukalapak>
            </b-card>
          </div>
          <div v-if="active == 'reminder'" :key="active">
            <b-card>
              <h1>REMINDER</h1>
              <b-row>
                <b-col>
                  <b-card class="border-bottom-success">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div
                          class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                        >Pickup Bulk Corporate Dashboard</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-box fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card class="border-bottom-success">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div
                          class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                        >Pickup Time Less Than 1 Hour</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-box fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </b-card>
                  <br />
                  <br />
                  <b-card class="border-bottom-warning">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div
                          class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                        >Re-Attemp Pickup(RAP)</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-box fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card class="border-bottom-warning">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div
                          class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                        >Pickup Time Less Than 30 Minutes</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-box fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card class="border-bottom-danger">
                    <div class="row no-gutters align-items-center">
                      <div class="col mr-2">
                        <div
                          class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                        >Pickup Time Missed</div>
                        <div class="h5 mb-0 font-weight-bold text-gray-800">20.000</div>
                      </div>
                      <div class="col-auto">
                        <i class="fas fa-box fa-2x text-gray-300"></i>
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </transition>
      </b-col>
    </b-row>
    <div class="text-left">

    </div>
    <!-- <button v-on:click="active = 'revenue'">Toggle</button>
    <transition name="fade">
      <p v-if="active == 'revenue'">hello</p>
      <p v-if="active == 'shipment'">hello</p>
      <p v-if="active == 'bukalapak'">hello</p>
      <p v-if="active == 'reminder'">hello</p>
    </transition>-->
    <!-- Content Row -->
    <!-- <div class="row">
      <div id="overlay-back"></div>
      <div>
        <app-tour></app-tour>
      </div>
    </div>-->
    <!-- <summer-note v-model="content" name="data" placeholder="COBA"></summer-note>
    {{content}}
    <br>
    <br>
    <br>
    <br>
    <br>
    <summer-note v-model="coba" name="more" placeholder="DATA2"></summer-note>
    {{coba}} -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ChartBar from "./chart/ChartBar.js";
import MyTour from "./MyTour.vue";
import summerNote from "@/components/Summernote.vue";

export default {
  components: {
    summerNote,
    appTour: MyTour,
    revenue: ChartBar,
    shipment: ChartBar,
    bukalapak: ChartBar
  },
  data() {
    return {
      coba:0,
      chartData: {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        datasets: [
          {
            barPercentage: 0.5,
            label: "Revenue This Week",
            data: [12, 15, 3, 5, 2, 3, 7],
            backgroundColor: "rgba(126,211,33,0.2)",
            borderColor: "rgba(126,211,33,1)",
            borderWidth: 2
          }
        ]
      },
      chartData2: {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        datasets: [
          {
            barPercentage: 0.5,
            label: "Shipment This Week",
            data: [10, 12, 14, 16, 18, 20, 22],
            backgroundColor: "rgba(96,81,162, 0.2)",
            borderColor: "rgba(96,81,162, 1)",
            borderWidth: 2
          }
        ]
      },
      chartData3: {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        datasets: [
          {
            barPercentage: 0.5,
            label: "Bukalapak Shipment This Week",
            data: [12, 15, 3, 5, 2, 3, 7],
            backgroundColor: "rgba(255,67,79, 0.2)",
            borderColor: "rgba(255,67,79, 1)",
            borderWidth: 2
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      active: "",
      content: "ISI CONTENT",
      html: "",
      datacollection: null,
      show: false,
      hover: false,
      id: this.$session.get("jwt")
    };
  },
  mounted() {
    
  },
  computed: {
    ...mapGetters(["doubleCounter", "stringCounter", "value"])
  },
  methods: {
    ubah(event){
      this.content = event
      console.log("EVENT", event)
    },
    changeView(payload) {
      this.active = payload;
    },
    ...mapActions(["increment", "decrement"]),
    updateValue(event) {
      this.$store.dispatch("updateValue", event.target.value);
    }
  }
};
</script>

<style scoped>
.small {
  max-width: 600px;
  margin: 150px auto;
}
.ganti {
  background: white;
  color: blue;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
